export default __webpack_public_path__ + "static/media/offenders.14d0ec53.png";